<template>
  <main id='Landing'>
    <MetaHeader v-if='size !== "phone"'/>
    <navigationBar @addReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil+1'
                   @removeReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil-1' />
    <transition name='basic'>
      <router-view name='overlay'
                   @addReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil+1'
                   @removeReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil-1'
                   :key='kirby.page.uri' />
    </transition>
    <veil :showveil='reasonsToShowTheVeil' />
    <transition name='basic'>
      <keep-alive v-if='$route.meta.keepAlive'>
        <router-view name='middleman' :key='kirby.page.uid' />
      </keep-alive>
      <router-view name='middleman' v-else :key='kirby.page.uid' />
    </transition>
    <transition name='basic'>
      <keep-alive v-if='$route.meta.keepAlive'>
        <router-view name='main' :key='kirby.page.url'/>
      </keep-alive>
      <router-view v-else name='main' :key='kirby.page.url' />
    </transition>
    <subscribe v-if='!kiosk' />
  </main>
</template>

<style>

.basic-enter-active {
  transition: opacity 0.5s cubic-bezier(0.74,0.11,0.56,1);
}
.basic-enter-to {
  opacity: 1;
}
.basic-enter {
  opacity: 0;
}
.basic-leave-to {
  opacity: 0;
}
.basic-leave {
  transition: opacity 0.33s cubic-bezier(0.74,0.11,0.56,1);
  opacity: 1;
}

main:empty {
  display: none;
}

</style>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins],
  props: ['active', 'results'],
  data: function() {
    return {
      reasonsToShowTheVeil: 0,
    }
  },
}
</script>
